import { styled } from "theme/default/styled";
import { setFlexDFFDC } from "theme/setter/setFlexValues/setFlexDFFDC";

export const SCreateUserSelect = styled.div`
  gap: 8px;

  ${setFlexDFFDC};
`;
